import { render, staticRenderFns } from "./ButtonErrorInstrument.vue?vue&type=template&id=45d88cda&scoped=true"
import script from "./ButtonErrorInstrument.vue?vue&type=script&lang=js"
export * from "./ButtonErrorInstrument.vue?vue&type=script&lang=js"
import style0 from "./ButtonErrorInstrument.vue?vue&type=style&index=0&id=45d88cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d88cda",
  null
  
)

export default component.exports